module.exports = __webpack_public_path__ + "img/discord@2x.330c60a5.svg";